import * as S from './style';

interface FieldProps {
	title: string;
	children: React.ReactNode;
}

const FieldTextarea = ({ title, children }: FieldProps) => (
	<S.Container>
		<S.Label>{title}</S.Label>
		{children}
	</S.Container>
);
export default FieldTextarea;
